import axios from 'axios'
import Cookies from "js-cookie";
import { LOGIN_FAIL, LOGIN_REQUEST, LOGIN_SUCCESS, SIGNUP_REQUEST, SIGNUP_SUCCESS } from './actionTypes';
export const login = (data) => (dispatch) => {
  // Complete login logic here
  let modernFurnitureLoginMessage ;
  dispatch({ type: LOGIN_REQUEST });
  return axios.post('https://randomloginsignup.onrender.com/users/login', data).then((res) => {
   // console.log(res.data.token);
    modernFurnitureLoginMessage = res.data.msg;
    dispatch({ type: LOGIN_SUCCESS, payload: res.data.token })
  }).catch((err) => {
    dispatch({ type: LOGIN_FAIL });
    modernFurnitureLoginMessage = err.response.data.error;
  }).finally(()=>{
    Cookies.set("modernFurnitureLoginMessage",modernFurnitureLoginMessage);
  })
};
export const signup = (data) => (dispatch) => {
  // Complete login logic here
  let modernFurnitureSignupMessage ;
 // console.log(data);
  dispatch({ type: SIGNUP_REQUEST });
  return axios.post('https://randomloginsignup.onrender.com/users/register', data).then((res) => {
    //console.log(res.data.token);
    modernFurnitureSignupMessage = res.data.msg;
   // console.log(res.data);
    dispatch({ type: SIGNUP_SUCCESS, payload: res.data })
  }).catch((err) => {
    modernFurnitureSignupMessage = err.response.data.error
    dispatch({ type: LOGIN_FAIL })

  }).finally(()=>{
    Cookies.set("modernFurnitureSignupMessage",modernFurnitureSignupMessage);
  })
};